module.exports = __webpack_public_path__ + "static/media/helengeli-24.03b7ed2e.jpg";